import React, { useContext } from "react";
import { useState } from "react";
import { ContextProvider } from "../Context/SharedStateContext";
import { useNavigate } from "react-router-dom";
import { Link } from "react-router-dom";
import Header from "../../Epic-X/Components/Header";
import Footer from "../../Epic-X/Components/Footer";

const PopupPrice = () => {
  const navigate = useNavigate();
  const { setPlanSelected, setPlanTypeSelected } = useContext(ContextProvider);
  const [isYearly, setIsYearly] = useState(false);

  const togglePricing = () => {
    setIsYearly(!isYearly);
  };

  const pricingPlans = [
    {
      title: "Free",
      description: "Best for personal use",
      monthlyPrice: "$0",
      yearlyPrice: "$0",
      features: [
        "1,000 impressions/month (est 5K pageviews)",
        "Unlimited popups",
        "Unlimited autoresponders",
        "All features",
        "Branded",
        "Chat & email support",
      ],
      planName: "free",
    },
    {
      title: "Growth",
      description: "Best for personal use",
      monthlyPrice: "$7.99",
      yearlyPrice: "$79",
      features: [
        "20,000 impressions/month (est 100K pageviews)",
        "Unlimited popups",
        "Unlimited autoresponders",
        "All features",
        "Unbranded",
        "Chat & email support",
      ],
      planName: "growth",
    },
    {
      title: "Professional",
      description: "Best for personal use",
      monthlyPrice: "$34.99",
      yearlyPrice: "$349",
      features: [
        "100,000 impressions/month (est 500K pageviews)",
        "Unlimited popups",
        "Unlimited autoresponders",
        "All features",
        "Unbranded",
        "Chat & email support",
      ],
      planName: "professional",
    },
    {
      title: "Premium",
      description: "Best for personal use",
      monthlyPrice: "$69.99",
      yearlyPrice: "$699",
      features: [
        "200,000 impressions/month (est 1M pageviews)",
        "Unlimited popups",
        "Unlimited autoresponders",
        "All features",
        "Unbranded",
        "Chat & email support",
      ],
      planName: "premium",
    },
  ];

  function handleGetStarted(plans) {
    const product = `popup`;
    const pricingType = isYearly ? "year" : "month";
    setPlanSelected(plans);
    setPlanTypeSelected(pricingType);
    // navigate(`/Register?product=${product}&plan=${plans}&type=${pricingType}`);
    // Open in a new tab
    window.open("https://apps.shopify.com/epic-x-popup", "_blank");
  }

  return (
    <div>
      {/* Header Start */}
      <Header />
      <div className="container-fluid bg-breadcrumb">
        <div
          className="container text-center py-5"
          style={{ maxWidth: "900px" }}
        >
          <h4
            className="text-white display-4 mb-4 wow fadeInDown"
            data-wow-delay="0.1s"
          >
            Pricing
          </h4>
          <ol
            className="breadcrumb d-flex justify-content-center mb-0 wow fadeInDown"
            data-wow-delay="0.3s"
          >
            <li className="breadcrumb-item">
              <Link to={"/"}>Home</Link>
            </li>
            <li className="breadcrumb-item active text-primary">Pricing</li>
          </ol>
        </div>
      </div>
      {/* Header End */}

      {/* Pricing Section Start */}
      <div className="container-fluid py-5">
        <div className="epic-x-pricing-container">
          <div className="text-center">
            <h2 className="epic-x-heading">
              Streamline your teamwork. Start free.
            </h2>
            <p className="epic-x-subheading">
              Choose the perfect plan for your business needs
            </p>
          </div>
          <div className="epic-x-toggle-container">
            <span className="epic-x-toggle-label">Pay Monthly</span>
            <label className="epic-x-switch">
              <input
                type="checkbox"
                id="toggle"
                checked={isYearly}
                onChange={togglePricing}
              />
              <span className="epic-x-slider epic-x-round"></span>
            </label>
            <span className="epic-x-toggle-label">Pay Yearly</span>
          </div>
          <div className="epic-x-pricing-plans">
            {pricingPlans.map((plan, index) => (
              <div key={index} className={`epic-x-plan`}>
                <h3 className="epic-x-plan-title">{plan.title}</h3>
                <p className="epic-x-plan-description">{plan.description}</p>
                <p className="epic-x-price">
                  {isYearly ? plan.yearlyPrice : plan.monthlyPrice}{" "}
                  <span className="epic-x-price-duration">
                    / {isYearly ? "Year" : "Month"}
                  </span>
                </p>
                <button
                  className="epic-x-button"
                  onClick={() => handleGetStarted(plan.planName)}
                >
                  Get Started Now
                </button>
                <h6 className="epic-x-features-title">What you get:</h6>
                <ul className="epic-x-features">
                  {plan.features.map((feature, i) => (
                    <li key={i} className="epic-x-feature">
                      {feature}
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
        </div>
      </div>
      {/* Pricing Section End */}
      <Footer />
    </div>
  );
};

export default PopupPrice;
